import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';

export class RecruitmentTypeService {
   async getRecruitmentTypes() {
      return await http.get(`/recruitment-types`, cacheFirstConfig).then((response: any) => {
         return response.data;
      });
   }
}
